import { render, staticRenderFns } from "./CelebTable.vue?vue&type=template&id=7b3f4308&scoped=true"
import script from "./CelebTable.vue?vue&type=script&lang=js"
export * from "./CelebTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3f4308",
  null
  
)

export default component.exports